function escapeTooltipText(value) {
    return String(value ?? "").replace(/[&<>"']/g, (character) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
    })[character]);
}

function displayValue(value, formatter) {
    return value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value))
        ? escapeTooltipText(formatter(Number(value)))
        : "—";
}

export function formatProductAxisTooltip(params, {turnoverLabel, quantityLabel, formatNumber, formatCurrency}) {
    const item = Array.isArray(params) ? params[0] : params;
    if (!item) {
        return "";
    }

    const data = item.data ?? {};
    const title = escapeTooltipText(data.productName ?? item.axisValueLabel ?? item.name ?? "");
    const turnover = displayValue(data.turnover, formatCurrency);
    const quantity = displayValue(data.quantity, formatNumber);

    return `<div style="font-weight:600;margin-bottom:6px">${title}</div>`
        + `<div>${escapeTooltipText(turnoverLabel)}<span style="float:right;margin-left:16px;font-weight:600">${turnover}</span></div>`
        + `<div>${escapeTooltipText(quantityLabel)}<span style="float:right;margin-left:16px;font-weight:600">${quantity}</span></div>`;
}
